<app-season-base-form-header translationKey="social-criteria" [enableIcon]="enableIcon()" [(isDisabled)]="isDisabled" />
<form class="flex flex-col mb-4" [formGroup]="socialCriteria()">
    <div class="max-w-[500px]">
        <div class="flex flex-row justify-between text-[rgb(var(--ui-5))]">
            <p>{{ 'seasons.season-creation.social-criteria.criteria-column-label' | translate }}</p>
            <p class="pr-5">{{ 'seasons.season-creation.social-criteria.weight-column-label' | translate }}</p>
        </div>
        @for (criteria of socialCriterias; track criteria) {
            <app-weight-counter
                [label]="criteria.socialCriteriaLabel | translate"
                [formControl]="getCriterion(criteria.criterion)"
                [min]="0"
                [max]="10"
                [isDisabled]="isDisabled()"
            ></app-weight-counter>
        }
    </div>
</form>
